import axios from 'axios';
axios.defaults.withCredentials = true;

// Use same domain in production (nginx proxies /api to backend)
const API_BASE = process.env.NODE_ENV === 'production'
  ? ''  // Empty = same origin (flo.com.co, nginx proxies /api to Django)
  : 'http://46.224.193.172:8000';  // Development backend URL on Hetzner

export default API_BASE; 